var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExcel = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "evenodd",
  d: "M22.568 2H7.91a1.78 1.78 0 0 0-1.255.527c-.333.336-.52.79-.52 1.265v7.938h16.432V2Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  fillRule: "evenodd",
  d: "M39 11.73V3.792a1.8 1.8 0 0 0-.52-1.265A1.77 1.77 0 0 0 37.226 2H22.567v9.73z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  fillRule: "evenodd",
  d: "M22.568 11.73H6.135v8.756h16.433z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  fillRule: "evenodd",
  d: "M39 20.486V11.73H22.567v8.756z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  fillRule: "evenodd",
  d: "M22.568 20.486H6.135v8.757h16.433z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#f)",
  fillRule: "evenodd",
  d: "M39 29.243v-8.757H22.567v8.757z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#g)",
  fillRule: "evenodd",
  d: "M22.567 38h14.661c.47-.002.92-.171 1.252-.472s.519-.709.52-1.134v-7.15H22.567z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#h)",
  fillRule: "evenodd",
  d: "M7.925 38h14.643v-8.757H6.135v7.158c.004.427.194.835.53 1.134.335.3.788.467 1.26.465",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#i)",
  fillRule: "evenodd",
  d: "M2.505 28.556H18.41c.399 0 .78-.151 1.063-.418s.441-.628.443-1.006v-15.07a1.4 1.4 0 0 0-.443-1.006 1.55 1.55 0 0 0-1.063-.418H2.505c-.398 0-.78.151-1.062.418A1.4 1.4 0 0 0 1 12.062v15.07c.001.378.16.74.443 1.006.282.267.664.417 1.062.418",
  clipRule: "evenodd"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#j)",
  fillRule: "evenodd",
  d: "M2.505 28.556H18.41c.399 0 .78-.151 1.063-.418s.441-.628.443-1.006v-15.07a1.4 1.4 0 0 0-.443-1.006 1.55 1.55 0 0 0-1.063-.418h-.097c.393 0 .77.15 1.05.412.278.264.435.621.436.994v14.988a1.37 1.37 0 0 1-.437.993 1.53 1.53 0 0 1-1.05.413H2.609a1.54 1.54 0 0 1-1.053-.41 1.38 1.38 0 0 1-.439-.996V12.044c.002-.373.159-.73.438-.994a1.53 1.53 0 0 1 1.049-.412h-.098c-.398 0-.78.151-1.062.418A1.4 1.4 0 0 0 1 12.062v15.07c.001.378.16.74.443 1.006.282.267.664.417 1.062.418",
  clipRule: "evenodd"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#k)",
  fillRule: "evenodd",
  d: "M6.248 14.896h2.431l1.798 3.51 2.063-3.51h2.245l-2.981 4.663 3.089 4.692h-2.315l-2.101-3.648-2.101 3.648H5.985l3.244-4.692z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 21.733,
  x2: 7.397,
  y1: 19.633,
  y2: 12.176,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#159857"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0D7A46"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 38.971,
  x2: 24.644,
  y1: 19.927,
  y2: 12.483,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2CDD93"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#13AB63"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 21.682,
  x2: 8.035,
  y1: 28.335,
  y2: 20.454,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#14874C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0A6E3C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 39.071,
  x2: 25.426,
  y1: 28.335,
  y2: 20.456,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#22D885"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B9457"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 21.682,
  x2: 8.033,
  y1: 37.602,
  y2: 29.722,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#164A2C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#113E26"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 39.072,
  x2: 25.424,
  y1: 37.602,
  y2: 29.724,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#20C172"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A7E4B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 39.12,
  x2: 25.482,
  y1: 46.558,
  y2: 38.69,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2D6E44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#194B2D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: 21.898,
  x2: 8.246,
  y1: 46.303,
  y2: 38.425,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#164E30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#173C27"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: 19.814,
  x2: 0.868,
  y1: 30.396,
  y2: 24.242,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0B7C3C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0A5026"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: 0.238,
  x2: 20.257,
  y1: 27.607,
  y2: 27.607,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4C9B6A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#156C37"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29A95F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: 5.515,
  x2: 14.942,
  y1: 27.583,
  y2: 27.583,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CFCF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEFEFE"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgExcel);
export default ForwardRef;